import { gql } from "@apollo/client";
// import { gql, useQuery, useApolloClient } from "@apollo/client";

import { ADDRESS_FIELDS } from "@/components/gform/fields/address-field";
import { CAPTCHA_FIELDS } from "@/components/gform/fields/captcha-field";
import { CHECKBOX_FIELDS } from "@/components/gform/fields/checkbox-field";
import { DATE_FIELDS } from "@/components/gform/fields/date-field";
import { EMAIL_FIELDS } from "@/components/gform/fields/email-field";
import { MULTI_SELECT_FIELDS } from "@/components/gform/fields/multiselect-field";
import { NAME_FIELDS } from "@/components/gform/fields/name-field";
import { PHONE_FIELDS } from "@/components/gform/fields/phone-field";
import { RADIO_FIELDS } from "@/components/gform/fields/radio-field";
import { SELECT_FIELDS } from "@/components/gform/fields/select-field";
import { TEXTAREA_FIELDS } from "@/components/gform/fields/textarea-field";
import { TEXT_FIELDS } from "@/components/gform/fields/text-field";
import { TIME_FIELDS } from "@/components/gform/fields/time-field";
import { WEBSITE_FIELDS } from "@/components/gform/fields/website-field";

// const client = getClient();
// export default async function getGravityForm(formId) {
//   const result = await client.query({
//     query: GET_FORM,
//     variables: { formId },
//   });
//   // console.log(formId);
//   console.log(result);

//   return result?.data?.gravityFormsForm;
// }

// export default async function getGravityForm(formId) {
//   console.log(formId);
//   const result = "";
//   // const result = useQuery(GET_FORM, { variables: formId });
//   // console.log(result);

//   return result?.data?.gravityFormsForm;
// }

// TODO: commented out fragments not working after update - check/fix

const formFields = `
  id
  databaseId
  title
  description
  confirmations {
    isDefault
    message
  }
  formFields {
    nodes {
      id
      type
      #     ... on GfFieldWithLabelSetting {
      #   label
      # }
      # ... on GfFieldWithRulesSetting {
      #   isRequired
      # }
      # ... on GfFieldWithAddressSetting {
      #   defaultState
      #   defaultCountry
      #   defaultProvince
      #   addressType
      # }
      # ... on GfFieldWithInputs {
      #   inputs {
      #     id
      #     label
      #     ... on AddressInputProperty {
      #       autocompleteAttribute
      #       customLabel
      #       placeholder
      #     }
      #   }
      # }
      # ... on GfFieldWithChoices {
      #   choices {
      #     text
      #     value
      #     ... on GfFieldChoiceWithChoicesSetting {
      #       isSelected
      #     }
      #     # ... on ChainedSelectFieldChoice {
      #     #   choices {
      #     #     text
      #     #     value
      #     #     isSelected
      #     #   }
      #     # }
      #   }
      # }
      ... on AddressField {
        ...AddressFields @unmask(mode: "migrate")
      }
      ... on CaptchaField {
        ...CaptchaFields @unmask(mode: "migrate")
      }
      ... on CheckboxField {
        ...CheckboxFields @unmask(mode: "migrate")
      }
      ... on DateField {
        ...DateFields @unmask(mode: "migrate")
      }
      ... on EmailField {
        ...EmailFields @unmask(mode: "migrate")
      }
      ... on MultiSelectField {
        ...MultiSelectFields @unmask(mode: "migrate")
      }
      ... on NameField {
        ...NameFields @unmask(mode: "migrate")
      }
      ... on PhoneField {
        ...PhoneFields @unmask(mode: "migrate")
      }
      ... on RadioField {
        ...RadioFields @unmask(mode: "migrate")
      }
      ... on SelectField {
        ...SelectFields @unmask(mode: "migrate")
      }
      ... on TextField {
        ...TextFields @unmask(mode: "migrate")
      }
      ... on TextAreaField {
        ...TextAreaFields @unmask(mode: "migrate")
      }
      ... on TimeField {
        ...TimeFields @unmask(mode: "migrate")
      }
      ... on WebsiteField {
        ...WebsiteFields @unmask(mode: "migrate")
      }
    }
  }
`;

export const GET_FORM_QUERY = gql`
  query getForm($databaseId: ID!) {
    gfForm(id: $databaseId, idType: DATABASE_ID) {
      ${formFields}
    }
  }
  ${ADDRESS_FIELDS}
  ${CAPTCHA_FIELDS}
  ${CHECKBOX_FIELDS}
  ${DATE_FIELDS}
  ${EMAIL_FIELDS}
  ${MULTI_SELECT_FIELDS}
  ${NAME_FIELDS}
  ${PHONE_FIELDS}
  ${RADIO_FIELDS}
  ${SELECT_FIELDS}
  ${TEXTAREA_FIELDS}
  ${TEXT_FIELDS}
  ${TIME_FIELDS}
  ${WEBSITE_FIELDS}
`;

export const GET_FORM_FRAGMENT = gql`
  fragment getForm on GfForm{
    ${formFields}
  }
  ${ADDRESS_FIELDS}
  ${CAPTCHA_FIELDS}
  ${CHECKBOX_FIELDS}
  ${DATE_FIELDS}
  ${EMAIL_FIELDS}
  ${MULTI_SELECT_FIELDS}
  ${NAME_FIELDS}
  ${PHONE_FIELDS}
  ${RADIO_FIELDS}
  ${SELECT_FIELDS}
  ${TEXTAREA_FIELDS}
  ${TEXT_FIELDS}
  ${TIME_FIELDS}
  ${WEBSITE_FIELDS}
`;
